<nav class="menu">
  <ul>
    <li class="active">{{ menuItems[0] }}</li>
    <li>{{ menuItems[1] }}</li>
  </ul>
</nav>